export default __webpack_public_path__ + "static/media/payment_success_icon.059903fd.gif";